// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

var API_ENDPOINT = 'https://www.gov.co';
var URL_BASE_GOVCO = 'https://www.gov.co';
var URL_BASE_BDC = 'https://cdn.www.gov.co';

export const environment = {
  production: false,
  repositoryCode: {
    urlBase: 'https://gitlab.com/govco/layout-govco/-/blob/v5/',
    pathBranch: '/-/blob/stage/',
  },
  cdn: `${URL_BASE_BDC}/`,
  cdnUrl: 'https://cdn.www.gov.co/layout-govco-v5/',
  pathBranchIcon: '/-/raw/master/src/assets/icons/',
  imagesUrl: `${URL_BASE_BDC}/v5/assets/images/`,

  // Aplicaciones y servicios Gov.co
  homeUrl: `${URL_BASE_GOVCO}/`,
  carpetaciudadanaUrl: 'https://carpetaciudadana.and.gov.co/',
  tramitesUrl: `${URL_BASE_GOVCO}/ficha-tramites-y-servicios/codigos-ciiu-y-tramites`,

  // Servicios para entidades
  urlPlanIntegracion:
    'https://admin.www.gov.co/Autenticacion/Autenticacion/RegistroAutoridad',
  urlBiblioteca: `${URL_BASE_GOVCO}/biblioteca/`,
  urlCajadeHerramientas: `${URL_BASE_GOVCO}/caja-de-herramientas`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
/*
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
*/
